"use client";

import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@radix-ui/react-tooltip";
import { LucideIcon } from "lucide-react";

export const EditorOptionButton = ({
	icon: Icon,
	active,
	hidden,
	disabled,
	title,
	onClick,
}: {
	icon: LucideIcon;
	active?: boolean;
	hidden?: boolean;
	disabled?: boolean;
	title?: string;
	onClick: () => void;
}) => {
	return !hidden ? (
		<TooltipProvider>
			<Tooltip delayDuration={0}>
				<TooltipTrigger
					type="button"
					onClick={onClick}
					className={cn(
						"rounded-lg p-2 text-sm text-gray-800 disabled:cursor-not-allowed disabled:opacity-60",
						active ? "bg-gray-300" : ""
					)}
					disabled={disabled}
				>
					<Icon className="h-4 w-4" />
				</TooltipTrigger>
				<TooltipContent>
					<p className="rounded border bg-white px-2 py-1 text-xxs font-medium text-gray-700">
						{title}
					</p>
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	) : null;
};
